<template>
  <div id="user-login">
    <div class="user-login-bg"></div>
    <div class="content-wrapper">
      <div class="login-wrapper">
        <Card :bordered="false">
          <p slot="title">
            <Icon type="md-log-in"/>欢迎登录DQ管理系统
          </p>
          <Form :model="loginData" :rules="loginValidate" ref="loginForm">
            <FormItem prop="username">
              <Input
                prefix="ios-contact"
                placeholder="请输入用户名"
                style="width: 100%"
                on-enter="login"
                v-model="loginData.username"
                @on-enter="login"
              />
            </FormItem>

            <FormItem prop="password">
              <Input
                prefix="md-lock"
                placeholder="请输入密码"
                type="password"
                style="width: 100%"
                on-enter="login"
                v-model="loginData.password"
                @on-enter="login"
              />
            </FormItem>

            <!-- <FormItem prop="mobile">
              <Input
                prefix="md-phone-portrait"
                placeholder="请输入手机"
                type="text"
                style="width: 100%"
                on-enter="login"
                v-model="loginData.mobile"
                @on-enter="login"
              />
            </FormItem>

            <FormItem prop="captcha_code">
              <Input
                placeholder="图形验证码"
                type="text"
                style="width: 66%"
                on-enter="login"
                v-model="loginData.captcha_code"
                @on-enter="login"
              />
              <img :src="captcha.captcha_image" alt="图形验证码" class="img-code" srcset="" @click="getCaptcha">
            </FormItem>

            <FormItem prop="verifyCode">
              <Input
                placeholder="短信验证码"
                type="text"
                style="width: 66%"
                on-enter="login"
                v-model="loginData.verifyCode"
                @on-enter="login"
              />
              <Button
                style="width: 30%; float:right;text-align: center;"
                @click="getVerifyCode"
                :disabled="isSending"
              >{{tips}}</Button>
            </FormItem> -->
            <Button type="primary" long @click="login" :loading="loading">
              {{loading? '正在登录。。。':'登录'}}
            </Button>
          </Form>
        </Card>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import { setTimeout } from 'timers';

export default {
  data() {
    return {
      loginData: {
        username: '',
        password: '',
        // mobile: '',
        // captcha_code: '',
        // verifyCode: '',
      },

      loginValidate: {
        username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        password: [{ required: true, message: '请输入用户密码', trigger: 'blur' }],
        // mobile: [
        //   { required: true, message: '请填写手机号', trigger: 'blur' },
        //   {
        //     validator: (rule, value, callback) => {
        //       if (this.com.util.verifyMobile(value)) {
        //         callback();
        //       } else {
        //         callback(new Error('手机格式错误'));
        //       }
        //     },
        //     trigger: 'blur',
        //   }],
        // captcha_code: [
        //   { required: true, message: '请填写图形验证码', trigger: 'blur' },
        //   {
        //     validator: (rule, value, callback) => {
        //       if (value.toLocaleUpperCase() === this.captcha.captcha_code.toLocaleUpperCase()) {
        //         callback();
        //       } else {
        //         callback(new Error('验证码错误'));
        //       }
        //     },
        //     trigger: 'blur',
        //   },
        // ],
        // verifyCode: [{ required: true, message: '请输入短信验证码', trigger: 'blur' }],
      },

      captcha: {},
      tips: '发送验证码',
      isSending: false,

      setIntervalSeconds: null,

      loading: false,
    };
  },

  methods: {
    login() {
      this.$refs.loginForm.validate((valid) => {
        if (!valid) return;

        this.loading = true;
        this.api.auth.auth(this.loginData).then((data) => {
          this.com.util.setCookie('authentication', data.access_token, data.expires_in);
          // this.$Message.success('登录成功！');
          this.$router.push('/');
        }).finally(() => {
          this.loading = false;
        });
      });
    },

    getCaptcha() {
      this.api.member.getCaptcha().then((data) => {
        this.captcha = data.captcha;

        this.loginData.verifyCode = '';
        this.loginData.captcha_code = '';
        this.tips = '发送验证码';
        this.isSending = false;

        if (this.setIntervalSeconds) {
          clearInterval(this.setIntervalSeconds);
          this.setIntervalSeconds = null;
        }
      });
    },

    getVerifyCode() {
      this.$refs.loginForm.validateField('mobile', (v1) => {
        this.$refs.loginForm.validateField('captcha_code', (v2) => {
          if (!v1 && !v2) {
            const params = {
              captcha: this.captcha,
              mobile: this.loginData.mobile,
            };
            this.api.member.getVerifycha(params).then((data) => {
              this.$Notice.success({
                title: '发送成功',
                desc: `验证码已发送到您的<br>
                手机(${this.loginData.mobile})，请注意查收，谢谢！`,
              });
            });

            this.isSending = true;
            let leftSeconds = 60;
            this.tips = `${leftSeconds}s后再获取`;
            this.setIntervalSeconds = setInterval(() => {
              leftSeconds -= 1;
              if (leftSeconds <= 0) {
                this.tips = '发送验证码';
                this.isSending = false;
                clearInterval(this.setIntervalSeconds);
                return;
              }
              this.tips = `${leftSeconds}s后再获取`;
            }, 1000);
          }
        });
      });
    },

    ...mapMutations(['setMenuData', 'setMenuList']),
  },

  created() {
    this.setMenuData(null);
    this.setMenuList(null);

    // this.getCaptcha();
  },

  beforeDestroy() {
    clearInterval(this.setIntervalSeconds);
    this.setIntervalSeconds = null;
  },
};
</script>

<style lang="less" scoped>
#user-login {
  width: 100%;
  height: 100%;
  .user-login-bg {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-size: cover;
    // background-image: url("../assets/img/login-bg.png");
  }

  .content-wrapper {
    position: absolute;
    top: -100px;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    max-width: 1080px;
    margin: 0 auto;
    .login-wrapper {
      position: absolute;
      right: 10px;
      top: 60%;
      -ms-transform: translateY(-60%);
      transform: translateY(-60%);
      width: 350px;
      .ivu-card {
        .ivu-card-head {
          p {
            display: inline-block;
            width: 100%;
            height: 20px;
            line-height: 20px;
            font-size: 16px;
            color: #1c2438;
            font-weight: 700;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }
    }
  }

  .img-code {
    cursor: pointer;
    width: 30%;
    height: 32px;
    float: right;
  }
}
</style>
